import { render, staticRenderFns } from "./table-controls.vue?vue&type=template&id=79303c8a&"
import script from "./table-controls.vue?vue&type=script&lang=js&"
export * from "./table-controls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports